import * as React from "react";

const RightArrowIcon: React.FC = () => {
    return (
        <svg width="32" height="24" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M31.75 3C31.75 3.57572 31.5303 4.15172 31.0908 4.59047L13.0908 22.5905C12.6531 23.032 12.0766 23.25 11.5 23.25C10.9234 23.25 10.3483 23.0303 9.90953 22.5908L0.909531 13.5908C0.470078 13.1531 0.25 12.5766 0.25 12C0.25 10.7147 1.30117 9.75 2.5 9.75C3.07572 9.75 3.65172 9.96973 4.09047 10.4092L11.5 17.8219L27.9109 1.41094C28.3469 0.970078 28.9234 0.75 29.5 0.75C30.7023 0.75 31.75 1.71328 31.75 3Z" fill="#3CA865"/>
</svg>
    );
};

export default React.memo(RightArrowIcon);
